export default "__VITE_ASSET__BH_DOaeB__"